import { render, staticRenderFns } from "./KurccGroupsPage.vue?vue&type=template&id=453d33b7&"
import script from "./KurccGroupsPage.vue?vue&type=script&lang=js&"
export * from "./KurccGroupsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports